import React from "react";
import Distribution from "../../components/modals/distributorModal";
import { useNavigate, useLocation } from "react-router-dom";

const AddDistributorPage = () => {
  const navigate = useNavigate();
  const location = useLocation();
  const editData = location.state?.row || null;

  const handleClose = () => {
    navigate("/partymanagement", { state: { selectedTabProp: 1 } });
  };

  const handleCloseSubmit = (savedData) => {
    navigate("/partymanagement", {
      state: { selectedTabProp: 1, savedDistributor: savedData },
    });
  };

  return (
    <div style={{ padding: "20px" }}>
      <Distribution
        open={true}
        status={!editData}
        dataProp={editData}
        onClose={handleClose}
        onClose1={handleCloseSubmit} // modal should call onClose1(savedData) on save
      />
    </div>
  );
};

export default AddDistributorPage;
